import { render, staticRenderFns } from "./SplitRequestSummary.vue?vue&type=template&id=2160fdd7&"
import script from "./SplitRequestSummary.vue?vue&type=script&lang=js&"
export * from "./SplitRequestSummary.vue?vue&type=script&lang=js&"
import style0 from "./SplitRequestSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VDivider,VIcon,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2160fdd7')) {
      api.createRecord('2160fdd7', component.options)
    } else {
      api.reload('2160fdd7', component.options)
    }
    module.hot.accept("./SplitRequestSummary.vue?vue&type=template&id=2160fdd7&", function () {
      api.rerender('2160fdd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scheduling/requests/SplitRequestSummary.vue"
export default component.exports